


















































import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class Navigator extends Vue {
  @Prop({ default: () => {} }) onNext;
  @Prop({ default: () => {} }) onCancel;
  @Prop({ default: 0 }) totalPage;
  @Prop({ default: 0 }) currentPage;
  @Prop() sections;
  @Prop() disableNext;
  @Prop() isFinished;
  @Prop() nextText;

  get filteredSections() {
    return this.sections.filter(section => section !== "SAVE_AND_EXIT");
  }

  get saveAndExitIndex() {
    return this.sections.indexOf('SAVE_AND_EXIT');
  }

  get canShowBackButton() {
    return this.currentPage && !this.isFinished;
  }
}
